<template>
  <nav-menu
    name="Group greeting cards"
    title="Send any card as a group greeting card"
    subtitle="Invite your group to sign remotely"
    action="View all cards"
    :icon="mdiCards"
    :to="{ name: 'catalog', query: { type: 'GROUP' } }"
    v-bind="$attrs" v-on="$listeners"
  >
    <div class="pa-3 d-flex flex-column-reverse d-sm-block">
      <div class="mt-3 mt-sm-0 float-sm-right" v-bind:style="{ width: $vuetify.breakpoint.xsOnly ? '100%' : '320px' }">
        <div class="mb-2 caption">Perfect for <router-link :to="{ name: 'business' }">business</router-link> (remote or in-person)</div>
        <v-card outlined>
          <v-responsive :aspect-ratio="16 / 9">
            <video width="100%" playsinline="" autoplay="autoplay" muted="muted" loop="loop" src="https://cdn.ellacard.com/nav/group_cards_320x246.mp4" class="d-block" />
          </v-responsive>
        </v-card>
        <div class="mt-2 mb-3 caption">Unlimited contributors, unlimited pages. Scheduled send via <span class="green--text">email</span> or <span class="green--text">text message</span>.</div>
      </div>

      <div>
        <div class="caption">Group cards for any occasion</div>
        <div
          v-for="[ name, q, icon ] in [
            [ 'Birthdays', 'Birthday', mdiCakeVariant ],
            [ 'Welcome to the team', 'Welcome', mdiAccountGroup ],
            [ 'Kudos / congrats', 'Congrats', mdiPartyPopper ],
            [ 'Work anniversaries', 'Work Anniversary', iconPathWorkAnniversary ],
            [ 'Retirement', 'Retirement', mdiBriefcaseCheck ],
            [ 'Condolences', 'Condolences', mdiEmoticonSad ],
            [ 'Design your own…', [ 'Template', 'blank' ], mdiPencilBoxOutline ]
          ]"
          class="mx-n2"
        >
          <v-btn text color="primary" :to="{ name: 'catalog', query: { q, type: 'GROUP' } }">
            <v-icon small class="mr-1" v-html="icon" />{{name}}
          </v-btn>
        </div>

        <template v-if="!global.xgc">
          <div class="mt-3 caption">Contribute to group gift cards</div>
          <div class="mx-n2">
            <v-btn text color="primary" :to="{ name: 'catalog-gift-cards' }">
              <v-icon small class="mr-1" v-html="mdiWalletGiftcard" />View all gift cards
            </v-btn>
          </div>
        </template>
      </div>
    </div>
  </nav-menu>
</template>

<script>
import NavMenu from '@/components/NavMenu.vue';
import cover from '@/assets/card-template-cover-3d.png';
import pages from '@/assets/pages-3d.png';
import iconPathWorkAnniversary from 'raw-loader!@/assets/icon-path-work-anniversary.txt';
import { mdiCakeVariant, mdiEmoticonSad, mdiCards, mdiAccountGroup, mdiPartyPopper, mdiCalendar, mdiBriefcaseCheck, mdiPencilBoxOutline, mdiWalletGiftcard } from '@mdi/js';

export default {
  name: 'nav-menu-group-greeting-cards',

  components: {
    NavMenu
  },

  created() {
    Object.assign(this, { cover, pages, iconPathWorkAnniversary, mdiCakeVariant, mdiEmoticonSad, mdiCards, mdiAccountGroup, mdiPartyPopper, mdiCalendar, mdiBriefcaseCheck, mdiPencilBoxOutline, mdiWalletGiftcard });
  }
}
</script>
